/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPIntermediaryDetailsViewModel } from './IAPIntermediaryDetailsViewModel';
import {
    IAPIntermediaryDetailsViewModelFromJSON,
    IAPIntermediaryDetailsViewModelFromJSONTyped,
    IAPIntermediaryDetailsViewModelToJSON,
} from './IAPIntermediaryDetailsViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfListOfIAPIntermediaryDetailsViewModel
 */
export interface ResultOfListOfIAPIntermediaryDetailsViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfListOfIAPIntermediaryDetailsViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfListOfIAPIntermediaryDetailsViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfListOfIAPIntermediaryDetailsViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfListOfIAPIntermediaryDetailsViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfListOfIAPIntermediaryDetailsViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfListOfIAPIntermediaryDetailsViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfListOfIAPIntermediaryDetailsViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {Array<IAPIntermediaryDetailsViewModel>}
     * @memberof ResultOfListOfIAPIntermediaryDetailsViewModel
     */
    data?: Array<IAPIntermediaryDetailsViewModel>;
    /**
     * 
     * @type {number}
     * @memberof ResultOfListOfIAPIntermediaryDetailsViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfListOfIAPIntermediaryDetailsViewModel interface.
 */
export function instanceOfResultOfListOfIAPIntermediaryDetailsViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfListOfIAPIntermediaryDetailsViewModelFromJSON(json: any): ResultOfListOfIAPIntermediaryDetailsViewModel {
    return ResultOfListOfIAPIntermediaryDetailsViewModelFromJSONTyped(json, false);
}

export function ResultOfListOfIAPIntermediaryDetailsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfListOfIAPIntermediaryDetailsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : ((json['Data'] as Array<any>).map(IAPIntermediaryDetailsViewModelFromJSON)),
        'count': json['Count'],
    };
}

export function ResultOfListOfIAPIntermediaryDetailsViewModelToJSON(value?: ResultOfListOfIAPIntermediaryDetailsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': value.data === undefined ? undefined : ((value.data as Array<any>).map(IAPIntermediaryDetailsViewModelToJSON)),
        'Count': value.count,
    };
}

